import Vue from 'vue';
import App from './index.vue';

import './utils/browser';
import './assets/css/reset.css';
import './assets/font/iconfont.css';
import router from './router'

Vue.config.productionTip = false;

// eslint-disable-next-line
new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
